import ApiService from '@/common/api.service';
import Toast from '@/common/toast';

const resource = 'auswertung';

const AuswertungService = {
    async get(slug) {
        let promise = null;
        try {
            promise = await ApiService.get(resource, slug);
        } catch (e) {
            Toast.showSaveErrorToastI18n('global.messages.toast.load_nok');
        }
        return promise;
    },
    async query(params) {
        return ApiService.query(resource, params);
    },
    async create(params) {
        let promise = null;
        try {
            promise = await ApiService.put(resource, params);
            Toast.showCreateOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async update(slug, params) {
        let promise = null;
        try {
            promise = await ApiService.put(resource, params);
            Toast.showSaveOkToastI18n();
        } catch (e) {
            Toast.showSaveErrorToastI18n();
        }
        return promise;
    },
    async delete(slug) {
        let promise = null;
        try {
            promise = await ApiService.delete(resource, slug);
            Toast.showDeleteOkToastI18n();
        } catch (e) {
            Toast.showDeleteErrorToastI18n();
        }
        return promise;
    },
};

export default AuswertungService;
